export default __webpack_public_path__ + "static/index-title-versions-ja-68a6fd41a4172fe4dd8d0e4d6cc1c56e.png";